module.exports = __webpack_public_path__ + "img/FO RND BLU BG.267c4fee.png";